import {
  applicationUserAccessFeatures,
  applicationFeatureType,
} from "@core/auth/permissions";
import {
  faBookOpen,
  faClock,
  faClockRotateLeft,
  faGavel,
  faHouse,
  faInfoCircle,
  faLayerGroup,
  faMagnifyingGlass,
  faPencil,
  faSlidersH,
  faStamp,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { composeMenuItems, withMenuItem } from "@layout/main-container/compose-menu-items";
import { environment } from "../environments/environment";
import { logHandlingMode } from "./routes/loghandling/loghandling";

export const menuItems = composeMenuItems(
  withMenuItem({
    label: "",
    children: [
      withMenuItem({
        label: $localize`Start`,
        icon: faHouse,
        routerLink: "/dashboard",
      }),
      withMenuItem({
        label: $localize`My profile`,
        icon: faUser,
        routerLink: "/profile",
      }),
      withMenuItem({
        label: $localize`User manual`,
        icon: faInfoCircle,
        href: `${environment.userManualUrl}?v=${environment.appVersion}`,
        target: "_blank",
        external: true,
      }),
    ],
  }),
  withMenuItem({
    label: $localize`Log Handling`,
    icon: faMagnifyingGlass,
    children: [
      withMenuItem({
        label: $localize`Signing`,
        icon: faPencil,
        routerLink: `/loghandling/${logHandlingMode.enum.Signing}`,
        features: [applicationFeatureType.enum.AccessLogSign],
      }),
      withMenuItem({
        label: $localize`Countersigning`,
        icon: faStamp,
        routerLink: `/loghandling/${logHandlingMode.enum.Countersigning}`,
        features: [applicationFeatureType.enum.AccessLogCountersign],
      }),
      withMenuItem({
        label: $localize`History`,
        icon: faClockRotateLeft,
        routerLink: "/history",
        features: [applicationFeatureType.enum.AccessLogHistory],
      }),
    ],
  }),
  withMenuItem({
    label: $localize`Administration`,
    icon: faBookOpen,
    children: [
      withMenuItem({
        label: $localize`User Management`,
        icon: faUsers,
        routerLink: "/admin/usermanager",
        features: [...applicationUserAccessFeatures],
      }),
      withMenuItem({
        label: $localize`Analysis Settings`,
        icon: faSlidersH,
        routerLink: "/admin/analysis-configuration",
        features: [applicationFeatureType.enum.AnalyzeConfigurationManagement],
      }),
      withMenuItem({
        label: $localize`Rule Handling`,
        icon: faGavel,
        routerLink: "/admin/rule-handling",
        features: [applicationFeatureType.enum.RuleConfigurationManagement],
      }),
      withMenuItem({
        label: $localize`Analysis`,
        icon: faLayerGroup,
        routerLink: "/admin/analysis",
        features: [applicationFeatureType.enum.AnalysisManagement],
      }),
      withMenuItem({
        label: $localize`Cron Jobs`,
        icon: faClock,
        routerLink: "/admin/cron-jobs",
        features: [applicationFeatureType.enum.SchedulerManagement],
      }),
    ],
  }),
);
